import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import './styles/styles.scss'
import { Provider } from 'react-redux'
import { store } from './store'
import AppLayout from './layout';
import { AppThemeProvider } from './theme/ThemeContext';
import 'bootstrap/dist/css/bootstrap.min.css'
import './index.css';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AppThemeProvider>
        <AppLayout />
      </AppThemeProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
